// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__1NKkt","sub_cont":"About_sub_cont__2p3hZ"};